module.exports = __webpack_public_path__ + "assets/img/ico_windows.8132d271.svg";